(function (ws) {
    'use strict';
    ws.views.preferences = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'user',
        GTM_EVENT_ACTION: 'change_preference',

        /**
         * event handlers
         */
        events: {
            'change .select-all-checkbox': 'checkAll',
            'change .prf-vendor-list li .custom-checkbox': 'switchSelectAll',
            'click #confirmSubmit': 'validateForm'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.vendorListForm = this.$('form#vendorListForm');
            this.confirmModalId = $('.confirm-modal').attr('id');
            this.$errorMsg = this.$('.error-message');
            this.$allSelectAllCheckboxes = this.$('.vendor-section').find('.prf-select-all .select-all-checkbox');
            this.$allCheckboxes = this.$('.vendor-section').find('.prf-vendor-list .custom-checkbox');
            this.$selectedCheckboxes = this.$('.vendor-section').find('.prf-vendor-list .custom-checkbox:checked');
            this.selectAllCheckboxes();
            this.checkedCheckboxes();
        },

        /**
         * Select all check boxes
         */
        checkAll: function (e) {
            $(e.target).parents('.vendor-section').find('.custom-checkbox').prop('checked', $(e.currentTarget).prop('checked'));
            this.$errorMsg.children().hide();
        },

        /**
         * Default selection
         */
        selectAllCheckboxes: function () {
            if (this.$selectedCheckboxes.length === 0) {
                $('#vendorListForm .custom-checkbox').prop('checked', 'true');
            }
        },

        /**
         * Check checked Checkboxes
         */
        checkedCheckboxes: function () {
            this.$allSelectAllCheckboxes.prop('checked', 'true');
            _.each(this.$allCheckboxes, function (checkbox) {
                if (!$(checkbox).is(':checked')) {
                    $(checkbox).closest('.vendor-section').find('.select-all-checkbox').prop('checked', false);
                }
            });
        },

        /**
         * Enable or disable select all checkbox based on vendor list checkbox selection
         */

        switchSelectAll: function (e) {
            var $checkboxes = $(e.target).parents('.vendor-section').find('.prf-vendor-list .custom-checkbox');
            var $selectedCheckboxes = $(e.target).parents('.vendor-section').find('.prf-vendor-list .custom-checkbox:checked');
            this.$errorMsg.children().hide();
            if ($checkboxes.length == $selectedCheckboxes.length) {
                $(e.target).parents('.vendor-section').find('.prf-select-all').find('.select-all-checkbox').prop('checked', 'true');
            } else {
                $(e.target).parents('.vendor-section').find('.prf-select-all').find('.select-all-checkbox').removeAttr('checked');
            }
        },

        /**
         * Form validation for vendor selection
         */
        validateForm: function (e) {
            e.preventDefault();
            var $selectedCheckboxes = $('.vendor-section').find('.prf-vendor-list .custom-checkbox:checked');
            var $notSelectedCheckboxes = $('.vendor-section').find('.prf-vendor-list .custom-checkbox:not(:checked)');
            if ($selectedCheckboxes.length == '0') {
                this.$errorMsg.children().show();
            } else {
                this.trackGTMVendorPreference($selectedCheckboxes);
                this.trackAdobeVendorPreferences($selectedCheckboxes, $notSelectedCheckboxes);
                this.vendorListForm.submit();
            }
        },

        /**
         * builds vendor preference GTM label and logs the event
         */
        trackGTMVendorPreference: function($selectedItems) {
            var vendorPreference;
            var comstorPreferences = [];
            var westconPreferences = [];
            var comstorAll = '';
            var westconAll = '';
            var comstorMsg;
            var westconMsg;

            //builds items array for each category
            _.each($selectedItems, function(item) {
                var $selectedItem = $(item);
                var preference = $selectedItem.data('preference');
                var name = $selectedItem.data('name');

                if (preference === 'Comstor') {
                    comstorPreferences.push(name);
                }
                else if (preference === 'Westcon') {
                    westconPreferences.push(name);
                }
            });

            //checks select all for each category
            _.each(this.$allSelectAllCheckboxes, function(selectAllChk) {
                var $selectAll = $(selectAllChk);

                if ($selectAll.data('preference') === 'Comstor' && $selectAll.is(':checked')) {
                    comstorAll = 'All';
                }

                if ($selectAll.data('preference') === 'Westcon' && $selectAll.is(':checked')) {
                    westconAll = 'All';
                }
            });

            comstorMsg = comstorAll.length > 0 ? 'Comstor_' + comstorAll : 'Comstor_' + comstorPreferences.join('-');
            westconMsg = westconAll.length > 0 ? '_Westcon_' + westconAll : '_Westcon_' + westconPreferences.join('-');

            vendorPreference =  comstorMsg + westconMsg;

            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, vendorPreference);
        },

        /**
         * builds vendor preference adobe label and logs the event
         */
        trackAdobeVendorPreferences: function ($selectedCheckboxes, $notSelectedCheckboxes) {
            let selectedCheboxArray = [];
            let notSelectedCheboxArray = [];
            dataLayerAA.event = {};
            dataLayerAA.event.action = 'change vendor preference';
            dataLayerAA.event.selected = '';
            dataLayerAA.event.notSelected = '';

            _.each($selectedCheckboxes, function (item) {
                selectedCheboxArray.push(item.value);
            });

            dataLayerAA.event.selected = selectedCheboxArray.join('|');

            _.each($notSelectedCheckboxes, function (item) {
                notSelectedCheboxArray.push(item.value);
            });

            dataLayerAA.event.notSelected = notSelectedCheboxArray.join('|');

            _satellite.track('event:user:user:preference');
        }
    });
})(westcon);
